import React, { useEffect, useState } from "react";
import { Grid, Button, Message, Header, List } from "semantic-ui-react";
import Handlebars from "handlebars";

Handlebars.registerHelper("ifEquals", function (arg1, arg2, options) {
  return arg1 === arg2 ? options.fn(this) : options.inverse(this);
});

const lpTemplate = `<?xml version="1.0" encoding="UTF-8"?>
<LinkPlanner file_version="2.0" app_version="5.4.9">
    <MetaData>File created on {{dateCreated}}</MetaData>
    <Project model="MODEL_ITU_530_17" use_clutter="0" default_subscriber_height="10">
    <Viewsheds>
    </Viewsheds>
    <Antennas>
    </Antennas>
    <SubscriberAntennas>
    </SubscriberAntennas>
    <CustomFields>
        <CustomFieldSet kind="access_point">
            <CustomField kind="text" sort_priority="access_point:0" id="CustomField:f65a38ba-5f0a-42a9-88ac-74cbcd8a827f" name="Altitude"/>
        </CustomFieldSet><CustomFieldSet kind="end">
        </CustomFieldSet><CustomFieldSet kind="hub">
        </CustomFieldSet><CustomFieldSet kind="link">
        </CustomFieldSet><CustomFieldSet kind="place">
        </CustomFieldSet><CustomFieldSet kind="project">
        </CustomFieldSet><CustomFieldSet kind="subscriber">
            <CustomField kind="text" sort_priority="pmp_links:0" id="CustomField:b3252492-fee1-4517-b530-eb54d24c88ba" name="Altitude"/>
            <CustomField kind="text" sort_priority="pmp_links:0" id="CustomField:ecb03179-d02d-4bac-8cb9-3bdb62df3ef7" name="ANP Sector"/>
        </CustomFieldSet>
        <CustomFieldSet kind="subscriber_place"></CustomFieldSet>
    </CustomFields>
    <CustomValues>
    </CustomValues>
    <Templates>
    </Templates>
    <Estimates>
        <PTPEstimates>
        </PTPEstimates>
        <PMPEstimates>
        <Hub_BOM>
        <OptionalExtras>
        </OptionalExtras>
        <OptionalRemoteExtras>
        </OptionalRemoteExtras>
        <GroupExtras>
        </GroupExtras>
        <UserEdits>
        </UserEdits>
        <CustomNotes>
        </CustomNotes>
        </Hub_BOM>
        </PMPEstimates>
        <WiFiEstimates>
        </WiFiEstimates>
        <SwitchEstimates>
        </SwitchEstimates>
    </Estimates>
    <PMPChannelPlans>
    </PMPChannelPlans>
    <TddSyncGroups>
        <TddSyncGroup max_burst_duration_p2="0" use_asymmetric_burst_duration="0" max_burst_duration="0" long_frame_duration="0" frame_duration="0"/>
        <TddSyncGroup max_burst_duration_p2="0" use_asymmetric_burst_duration="0" max_burst_duration="0" long_frame_duration="0" frame_duration="0"/>
    </TddSyncGroups>
    <Rules>
        <Rule name="Does not meet requirements" format="1" stop_execution="0" disabled="0" hidesm="0" boolean="any" excluded="0" hidden="0" format_settings="{&#34;colour&#34;: &#34;#ff0000&#34;}" description="Link fails to meet performance requirements or has warnings">
            <ExpressionGroup boolean="any">
                <Expression comparison_value="False" predicate="equal to" property="link_ok">
                </Expression>
            </ExpressionGroup>
        </Rule>
    </Rules>
    <Profiles>
    </Profiles>
    <PMPRules>
        <Rule name="Does not meet requirements" format="1" stop_execution="0" disabled="0" hidesm="0" boolean="any" excluded="0" hidden="0" format_settings="{&#34;colour&#34;: &#34;#ff0000&#34;}" description="Link fails to meet performance requirements or has warnings">
            <ExpressionGroup boolean="any">
                <Expression comparison_value="False" predicate="equal to" property="link_ok">
                </Expression>
            </ExpressionGroup>
        </Rule>
    </PMPRules>
    <APRules>
        <Rule name="Has warnings" format="1" stop_execution="0" disabled="0" hidesm="0" boolean="any" excluded="0" hidden="0" format_settings="{&#34;colour&#34;: &#34;#ff000096&#34;, &#34;text_colour&#34;: &#34;#ff0000&#34;}" description="The access point has warnings">
            <ExpressionGroup boolean="any">
                <Expression comparison_value="False" predicate="equal to" property="is_ok">
                </Expression>
            </ExpressionGroup>
        </Rule>
    </APRules>
    <BestServer sm_height_choice="2" group_name="All APs" height_above_clutter="3" height_above_ground="3" preferred_product_order="V1000,V3000">
        <SubscriberVariant fade_margin="0" mod_mode="p220_mcs1" family="cnRanger">
        </SubscriberVariant><SubscriberVariant fade_margin="0" mod_mode="ptp700_bpsk63s" family="PTP-700-HCMP">
        </SubscriberVariant><SubscriberVariant fade_margin="0" family="cnReach">
        </SubscriberVariant><SubscriberVariant fade_margin="0" mod_mode="epmp_qpsk_5_s" phy_type="11ac" family="ePMP">
        </SubscriberVariant><SubscriberVariant fade_margin="0" mod_mode="pmp450_qpsk_mimo_a" family="PMP-450">
        </SubscriberVariant><SubscriberVariant fade_margin="0" mod_mode="epmp_qpsk_5_s" phy_type="11n" family="ePMP">
        </SubscriberVariant><SubscriberVariant fade_margin="0" mod_mode="ptp700c_bpsk63s" family="PTP-670-HCMP">
        </SubscriberVariant><SubscriberVariant fade_margin="0" mod_mode="V3000Mode_mcs_2" family="cnWave">
        </SubscriberVariant>
    </BestServer>
    <Places>
        {{#each dnSites as | value key|}}
            {{#with value}}
                <Place name="{{name}}" place_id="{{placeId}}" maximum_height="{{../params.dnHeight}}" latitude="{{lat}}" longitude="{{lng}}">{{key}}</Place>
            {{/with}}
        {{/each}}
    </Places>
    <SubscriberPlaces>
        {{#each cnSites as | value key|}}
            {{#with value}}
                <Place name="{{name}}" place_id="{{placeId}}" maximum_height="{{../params.cnHeight}}" latitude="{{lat}}" longitude="{{lng}}">{{key}}</Place>
            {{/with}}
        {{/each}}
    </SubscriberPlaces>
    <Links>
    </Links>
    <Hubs>
        {{#each nodes as | value key|}}
        {{#with value}}
            {{#with (lookup ../dnSites key)}}
        <Hub place_id="{{placeId}}">
            <AccessPoints>
               <AccessPoint antenna="d289296b-f730-41a4-b2c0-0410fb26d76d" ap_id="{{value.accessPoint.apId}}"
                antenna_azimuth="{{value.accessPoint.azimuth}}" antenna_height="{{../../params.dnHeight}}" noise_density_sm="-114"
                noise_density="-114"  modelled_beamwidth="280">
                    <CustomValues>
                        <CustomValue field="CustomField:f65a38ba-5f0a-42a9-88ac-74cbcd8a827f" value="{{altitude}}"/>
                    </CustomValues>
                {{/with}}
                    <Sectors>
                        {{#each sectors}}
                            {{#ifEquals this.sectorPosition "1"}}
                        <Sector noise_density_sm="-114" noise_density="-114" antenna_height="{{../../params.dnHeight}}" modelled_beamwidth="280">
                            <Equipment polarity="POLARITY_{{this.polarity}}" golay="Auto" tx_channel="{{../../params.channel}}" sm_registration_limit="13" />
                        </Sector>
                            {{/ifEquals}}
                        {{/each}}
                    </Sectors>
                    {{#each sectors}}
                        <Equipment polarity="POLARITY_{{this.polarity}}" range_units="kilometers" product="V605000_PMP"
                            max_range_units="kilometers" golay="Auto" tx_channel="{{../../params.channel}}" regulation="other_L60"
                            sm_registration_limit="13" band="bandL60" sm_range="{{../accessPoint.smRange}}"/>
                    {{/each}}
                    <Subscribers>
                        {{#each (lookup ../links key) as | link index |}}
                        {{#with (lookup ../../cnSites link.remoteGeohash)}}
                            <Subscriber antenna="{{antennaId}}" description="{{link.length}}"
                             dirty="1" place_id="{{placeId}}" antenna_height="{{../../../params.cnHeight}}">
                                <Equipment product="{{productName}}" />
                                <PMPLink />
                                <CustomValues>
                                    <CustomValue field="CustomField:b3252492-fee1-4517-b530-eb54d24c88ba" value="{{altitude}}"/>
                                    <CustomValue field="CustomField:ecb03179-d02d-4bac-8cb9-3bdb62df3ef7" value="{{link.sectorPosition}}"/>
                                </CustomValues>
                            </Subscriber>
                        {{/with}}
                        {{/each}}
                    </Subscribers>
                </AccessPoint>
            </AccessPoints>
        </Hub>
        {{/with}}
        {{/each}}
    </Hubs>
    <MeshLinks>
        {{#each meshLinks as | linksArr localGeohash|}}
            {{#each linksArr as | value key|}}
                {{#with (lookup ../../nodes localGeohash)}}
        <MeshLink end1_id="{{accessPoint.apId}}"
                {{/with}}
                {{#with (lookup ../../nodes value.remoteGeohash)}}
            end2_id="{{accessPoint.apId}}" user_hide="0" colour="#ff0000" line_thickness="0"
                frame_size="None" terrain_roughness="6.096">
            <Local mean_data_rate_requirement="500" minimum_data_rate_requirement="{{value.dataFlow}}"
                    minimum_reliability_requirement="99.0" ethernet_cable="None"/>

            <Remote mean_data_rate_requirement="500" minimum_data_rate_requirement="{{value.dataFlow}}"
                    minimum_reliability_requirement="99.0" ethernet_cable="None"/>
        </MeshLink>
                {{/with}}
            {{/each}}
        {{/each}}
    </MeshLinks>
    </Project>
    <UI>
        <Tree state="[[0]]"/>
    </UI>
</LinkPlanner>`;

function Download({ data, prevStepHandler, params }) {
  const [downloadLink, setDownloadLink] = useState("");
  console.log("data", data);
  const cnSites = Object.values(data.cnSites).length;
  const dnSites = Object.values(data.dnSites).length;
  const dns = Object.values(data.nodes).length;
  let meshLinks = 0;
  let cns = 0;
  if (Object.values(data.meshLinks).length) {
    meshLinks = Object.values(data.meshLinks).reduce(
      (acc, ele) => (acc.length ? acc.length : acc) + ele.length,
      0
    );
  }
  if (Object.values(data.links).length) {
    cns = Object.values(data.links).reduce(
      (acc, ele) => (acc.length ? acc.length : acc) + ele.length,
      0
    );
  }
  useEffect(() => {
    const fileData = Handlebars.compile(lpTemplate)({
      ...data,
      params: params,
    });
    const blobObj = new Blob([fileData], { type: "text/ptpprj" });
    const blobUrl = window.URL.createObjectURL(blobObj);
    setDownloadLink(blobUrl);
  }, [data, params]);

  return (
    <>
      <Message>
        <Header as="h3">Project Summary</Header>
        <List horizontal>
          <List.Item>
            <List.Content>
              <List.Header>Network Sites</List.Header>
              {dnSites}
            </List.Content>
          </List.Item>
          <List.Item>
            <List.Content>
              <List.Header>Subscriber Sites</List.Header>
              {cnSites}
            </List.Content>
          </List.Item>
          <List.Item>
            <List.Content>
              <List.Header>DN's</List.Header>
              {dns}
            </List.Content>
          </List.Item>
          <List.Item>
            <List.Content>
              <List.Header>CN's</List.Header>
              {cns}
            </List.Content>
          </List.Item>
          <List.Item>
            <List.Content>
              <List.Header>Mesh Links</List.Header>
              {meshLinks}
            </List.Content>
          </List.Item>
        </List>
      </Message>
      <Message positive>
        {" "}
        LINKPlanner project file generated, download{" "}
        <a href={downloadLink} download="ANP.ptpprj">
          here
        </a>
      </Message>
      <Grid>
        <Grid.Row>
          <Grid.Column floated="right" width={4}>
            <div className="fixed-button">
              <Button onClick={prevStepHandler}> Previous</Button>
              <Button
                onClick={() => {
                  window.location.reload();
                }}
              >
                Start New Import
              </Button>
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </>
  );
}

export default Download;
